import { Injectable, signal, Signal } from '@angular/core';
import { ChatMessage } from '../models/agent.models';
import { nanoid } from 'nanoid';

@Injectable({
  providedIn: 'root',
})
export class MessagesStateService {
  private messagesSignal = signal<ChatMessage[]>([]);

  getMessagesSignal(): Signal<ChatMessage[]> {
    return this.messagesSignal;
  }

  addMessage(message: ChatMessage): string {
    if (!message.messageId) {
      message.messageId = nanoid();
    }
    this.messagesSignal.update((messages) => [...messages, message]);
    console.log('Message added via MessagesStateService:', this.messagesSignal());
    return message.messageId;
  }

  updateMessage(messageId: string, updatedMessage: Partial<ChatMessage>, insertIfNotFound: boolean = false): boolean {
    let found = false;
    this.messagesSignal.update((messages) =>
      messages.map((message) => {
        if (message.messageId === messageId) {
          found = true;
          return { ...message, ...updatedMessage };
        }
        return message;
      }),
    );
    if (!found && insertIfNotFound) {
      const newMessage = { ...updatedMessage, messageId } as ChatMessage;
      this.addMessage(newMessage);
    }
    return found;
  }

  clearMessages(): void {
    this.messagesSignal.set([]);
  }
}
